import dayjs from 'dayjs';
import { sendMessage } from '../../api/aligo';
import Footer from '../../components/Footer';
import { useState } from 'react';

function Contact(props) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [memo, setMemo] = useState('');
  const [agree, setAgree] = useState(false);
  const sendPhoneMessage = async () => {
    const params = {
      sender: '010-5017-4031',
      receiver: '010-5017-4031',
      title: '[제품 문의 상담]',
      msg: `\n이름: ${name}\n핸드폰 번호: ${phone}\n문의내용:\n${memo}\n개인정보 동의: ${
        agree ? '동의' : '미동의'
      }\n신청일: ${dayjs().format('YYYY-MM-DD HH:mm:ss')}
      `,
      // testmode_yn: 'Y',
    };
    const res = await sendMessage(params);
    if (res) {
      initForm();
      alert('문의가 접수되었습니다.');
    }

    // 메시지 발송하기

    // req.body = {
    /*** 필수값입니다 ***/
    //   sender: 발신자 전화번호  // (최대 16bytes)
    //   receiver: 수신자 전화번호 // 컴마()분기 입력으로 최대 1천명
    //   msg: 메시지 내용	// (1~2,000Byte)
    /*** 필수값입니다 ***/
    //   msg_type: SMS(단문), LMS(장문), MMS(그림문자)
    //   title: 문자제목(LMS, MMS만 허용) // (1~44Byte)
    //   destination: %고객명% 치환용 입력
    //   rdate: 예약일(현재일이상) // YYYYMMDD
    //   rtime: 예약시간-현재시간기준 10분이후 // HHMM
    //   image: 첨부이미지 // JPEG, PNG, GIF
    // }
    // req.body 요청값 예시입니다.
    // const axiosConfig = {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //   },
    // };
    // const params = {
    //   key: "ho1yae29ulb4dose9fubrjdcife2crxv",
    //   user_id: "barunsash",
    //   sender: "01093314357",
    //   receiver: "01093314357",
    //   msg: "테스트 중입니다.",
    //   // 테스트모드
    //   testmode_yn: "Y",
    // };
    // axios
    //   .post("https://apis.aligo.in", params, axiosConfig)
    //   .then((res) => res.data)
    //   .catch((err) => {
    //     console.log("err", err);
    //   });
  };

  const initForm = () => {
    setName('');
    setPhone('');
    setMemo('');
    setAgree(false);
  };

  const onClickSend = () => {
    if (!agree) {
      alert('개인정보 수집 및 이용에 동의해주세요.');
      return;
    }
    if (!name) {
      alert('이름을 입력해주세요.');
      return;
    }
    if (!phone) {
      alert('전화번호를 입력해주세요.');
      return;
    }
    if (!memo) {
      alert('문의내용을 입력해주세요.');
      return;
    }
    sendPhoneMessage();
  };

  return (
    <>
      <div className='w-full h-full'>
        <div
          id='visual'
          className={`flex items-center justify-center flex-col bg-[url("/public/assets/images/contact/bg_visual.jpg")] bg-cover bg-center h-[282px] md:h-[554px]`}
        >
          <p
            className='text-center text-3xl md:text-[3.45rem] font-bold text-white md:leading-tight leading-5'
            data-aos='fade-up'
          >
            CONTACT US
          </p>
          <p
            className='mt-5 text-base font-medium text-center text-white md:mt-7 md:text-2xl'
            data-aos='fade-up'
            data-aos-duration='1000'
          >
            건강하고 아름다운 미래의 꿈
            <br className='md:hidden' /> 노아와 나아갑니다
          </p>
        </div>
        <div className='px-5 max-w-[751px] py-16 lg:py-40 mx-auto'>
          <p
            className='text-2xl font-bold leading-9 text-center lg:text-[2.85rem] lg:leading-[3rem]'
            data-aos='fade-up'
            data-aos-duration='5000'
          >
            제품 문의 상담
          </p>
          <p
            className='mt-3 text-base font-medium leading-6 text-center lg:text-xl lg:leading-8 lg:mt-6'
            data-aos='fade-up'
            data-aos-duration='6000'
          >
            <span className='md:block'>
              노아 제품에 대한 궁금하신 내용이나,
              <br className='md:hidden' /> 구매관련 문의를 원하실 경우
              <br className='md:hidden' />
            </span>{' '}
            아래 문의하기로 상담해주시면 <br className='md:hidden' />
            빠르게 회신 드리겠습니다.{' '}
          </p>
          <div className='mt-8' data-aos='fade-up' data-aos-duration='8000'>
            <input
              type='text'
              value={name}
              className='w-full h-[2.82rem] border-2 border-[#E4E3E3] px-4 placeholder:text-base text-base lg:h-16 lg:text-2xl placeholder:lg:text-2xl'
              onChange={(e) => setName(e.target.value)}
              placeholder='이름'
            />
            <input
              type='text'
              value={phone}
              className='mt-3 w-full h-[2.82rem] border-2 border-[#E4E3E3] px-4 placeholder:text-base text-base lg:h-16 lg:text-2xl placeholder:lg:text-2xl'
              onChange={(e) => setPhone(e.target.value)}
              placeholder='전화번호'
            />
            <textarea
              value={memo}
              className='p-3 mt-3 w-full h-[6.5rem] border-2 border-[#E4E3E3] px-4 placeholder:text-base text-base lg:text-2xl placeholder:lg:text-2xl lg:h-[202px]'
              placeholder='문의내용'
              onChange={(e) => setMemo(e.target.value)}
            ></textarea>
            <p className='mt-6 ml-4 text-base font-semibold lg:text-xl'>
              개인정보처리방침 동의
            </p>
            <div className='bg-[#F5F5F5] p-5 mt-2 overflow-hidden overflow-y-auto h-[176px]'>
              <div className='text-sm'>
                개인정보 수집 및 이용 동의
                <br />
                개인정보의 수집 및 이용 목적 : 문의에 대한 안내
                <br />
                수집하는 개인정보의 항목 <br />
                필수정보 : 이메일
                <br />
                <br />
                귀하는 개인정보 수집 및 이용에 동의하지 않으실 수 있으며, 동의
                거부시에는 문의를 접수하실 수 없습니다.
              </div>
            </div>
            <div className='flex gap-10 mt-2'>
              <div className='inline-flex items-center'>
                <label
                  className='relative flex items-center p-3 rounded-full cursor-pointer'
                  htmlFor='html'
                  data-ripple-dark='true'
                >
                  <input
                    id='html'
                    name='type'
                    type='radio'
                    checked={agree}
                    onClick={() => setAgree(true)}
                    className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border-2 border-[#CDCDCD] text-[#365DA5] transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#CDCDCD] checked:before:bg-[#365DA5] hover:before:opacity-10"
                  />
                  <div className='pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-[#365DA5] opacity-0 transition-opacity peer-checked:opacity-100'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='h-3.5 w-3.5'
                      viewBox='0 0 16 16'
                      fill='currentColor'
                    >
                      <circle data-name='ellipse' cx='8' cy='8' r='8'></circle>
                    </svg>
                  </div>
                </label>
                <label
                  className='mt-px font-medium cursor-pointer select-none lg:text-xl'
                  htmlFor='html'
                >
                  동의합니다.
                </label>
              </div>
              <div className='inline-flex items-center'>
                <label
                  className='relative flex items-center p-3 rounded-full cursor-pointer'
                  htmlFor='react'
                  data-ripple-dark='true'
                >
                  <input
                    id='react'
                    checked={!agree}
                    name='type'
                    type='radio'
                    onClick={() => setAgree(false)}
                    className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border-2 border-[#CDCDCD] text-[#365DA5] transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#CDCDCD] checked:before:bg-[#365DA5] hover:before:opacity-10"
                  />
                  <div className='pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-[#365DA5] opacity-0 transition-opacity peer-checked:opacity-100'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='h-3.5 w-3.5'
                      viewBox='0 0 16 16'
                      fill='currentColor'
                    >
                      <circle data-name='ellipse' cx='8' cy='8' r='8'></circle>
                    </svg>
                  </div>
                </label>
                <label
                  className='mt-px font-medium cursor-pointer select-none lg:text-xl'
                  htmlFor='react'
                >
                  동의하지 않습니다.
                </label>
              </div>
            </div>
            <button
              onClick={onClickSend}
              className='w-full block bg-[#103D80] text-center text-white font-medium text-base py-5 mt-12 lg:text-[1.38rem] lg:py-[1.6rem]'
            >
              문의하기
            </button>
          </div>
        </div>
        <div className='flex flex-col lg:flex-row justify-center items-center text-center bg-[url("/public/assets/images/contact/m_bg_water.jpg")] lg:bg-[url("/public/assets/images/contact/bg_water.jpg")] bg-cover bg-center h-[282px] lg:h-[528px]'>
          <div className='lg:text-left'>
            <p className='font-bold text-2xl leading-9 lg:text-[2.815rem] lg:leading-[4.065rem]'>
              젊은 생각, 앞선 걸음으로 <br />
              만드는 새로운 미래
            </p>
            <p className='mt-3 lg:mt-4 text-base font-medium leading-6 lg:text-xl lg:leading-[2.2rem]'>
              인간존중, 생명존중을 최우선으로
              <br className='lg:hidden' />
              하는 노아에서는 앞으로 전략을 추진하여
              <br />
              새로운 프로젝트를 완성해 나가겠습니다.
            </p>
          </div>
          <div className='hidden lg:block'>
            <img
              className='lg:block max-h-[479px]'
              src={`${process.env.PUBLIC_URL}/assets/images/contact/img_obj.png`}
              alt=''
            />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Contact;
